import { AuxCard } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DatapointIdStandardEnum } from "api/ux/src";
import { InsFacetedFilter } from "components/ux/ins-faceted-filter/insFacetedFilter";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
import { setCompositionRules } from "store/portfolio-creation";
export const InsPortfolioCreationRulesBasedTabBase = ({ useFiltersHook, GridComponent }) => {
    const [filters, queryState] = useFiltersHook();
    const dispatch = useDispatch();
    const compositionRules = useSelector((state) => state.portfolioCreation?.compositionRules);
    const information = useSelector((state) => state.portfolioCreation?.information);
    const getFilteredFilters = () => {
        if (!information?.isSynchronizedWithCentral) {
            return filters;
        }
        const defaultFields = [
            DatapointIdStandardEnum.FundStrategy,
            DatapointIdStandardEnum.FundGeography,
            DatapointIdStandardEnum.FundVintageYear,
            DatapointIdStandardEnum.FundInvestorName
        ];
        return filters
            .map((group) => ({
            ...group,
            data: group.data.filter((filter) => defaultFields.includes(filter.field))
        }))
            .filter((group) => group.data.length > 0);
    };
    const filteredFilters = getFilteredFilters();
    const clearFilterValues = () => {
        dispatch(setCompositionRules({}));
    };
    const applyFilterValues = (values) => {
        dispatch(setCompositionRules(values));
    };
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "aux-g32--cw-2" },
            React.createElement(AuxCard, null,
                React.createElement(InsQueryStatedElement, { queryState: queryState, hasData: filteredFilters.length > 0 },
                    React.createElement(InsFacetedFilter, { autoMode: true, filters: filteredFilters ?? [], stateFilterValues: compositionRules ?? {}, onClickCleanFilters: clearFilterValues, onClickApply: applyFilterValues })))),
        React.createElement("div", { className: "aux-g32--cw-8" },
            React.createElement(GridComponent, null)));
};
